<template>
  <tab-layout :actionBar="true">
    <register :isAdmin="true" slot="tabContent" class="row mx-0 show active" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import register from '@/views/Account/Register'

export default {
  name: 'AdminRegister',
  components: {
    'tab-layout': tabLayout,
    register
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Register/Register.vue